import microphonePermissionStates from '../../consts/aiAssistant/microphonePermissionStates';
import log from '../logger/log';

const getPermissionState = async () => {
    try {
        if (!navigator.permissions?.query) return microphonePermissionStates.UNKNOWN;

        const status = await navigator.permissions.query({name: 'microphone'});

        return status?.state || microphonePermissionStates.UNKNOWN;
    } catch (e) {
        log.warn('microphonePermissionService: microphone permission check failed', e);

        return microphonePermissionStates.UNKNOWN;
    }
};

// The only cross-browser way to show the native prompt; the stream is released right away
const requestPermission = async () => {
    try {
        const stream = await navigator.mediaDevices?.getUserMedia({audio: true});

        if (!stream) return microphonePermissionStates.DENIED;

        stream.getTracks().forEach((track) => track.stop());

        return microphonePermissionStates.GRANTED;
    } catch (e) {
        log.info('microphonePermissionService: microphone access request rejected');
        log.warn('microphonePermissionService: getUserMedia failed', e);

        return microphonePermissionStates.DENIED;
    }
};

export default {getPermissionState, requestPermission};
